import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
// import { LineChart } from 'chartist';
import UrlHelpers from '../../shared/url_helpers';

import { APIRequest, UserStore } from '@reverbdotcom/discovery-ui';
import LineGraph from '@reverbdotcom/discovery-ui/src/components/price_guide_tool/graph/line_graph';

import Money from '../../shared/money';
import classNames from 'classnames';

const MIN_SUMMARIES = 3;
const NUMBER_OF_MONTHS_DEFAULT = 12;
const DEFAULT_CONDITION = 'used';
const COMPARISON_SHOPPING_PAGE = 'comparisonShoppingPage';

function params() {
  return {
    number_of_months: NUMBER_OF_MONTHS_DEFAULT,
    condition: DEFAULT_CONDITION,
  };
}

function url(objectId, objectType) {
  if (objectType === COMPARISON_SHOPPING_PAGE) {
    return UrlHelpers
      .comparisonShoppinagPageTransactionsSummaryPath(objectId, params());
  }

  return UrlHelpers.priceGuideTransactionsSummaryPath(objectId, params());
}

function userCurrency() {
  return UserStore.getState().currency;
}

function formatPrice(amountCents) {
  const money = new Money(amountCents, userCurrency());
  return money.toStringNoCents();
}

PriceGuideChart.propTypes = {
  objectId: PropTypes.number.isRequired,
  objectType: PropTypes.string,
  loadChart: PropTypes.bool,
};

function PriceGuideChart({
  loadChart = true,
  objectId,
  objectType = null,
}) {

  const [model, setModel] = React.useState(null);

  function buildChartData() {
    const priceFinals = [];
    const labels = [];

    model.summaries.forEach((summary) => {
      const shortMonthShortYear = 'MMM YY';
      labels.push(moment(summary.date).format(shortMonthShortYear));
      const priceFinal = summary.average_price_final.amount_cents;

      priceFinals.push(priceFinal);
    });

    return {
      chartData: {
        labels,
        series: [
          { name: I18n.t('js.transactionHistory.soldPrice'), data: priceFinals },
        ],
      },
      chartOptions: {
        axisY: {
          labelInterpolationFnc: value => formatPrice(value),
        },
      },
    };
  }

  React.useEffect(() => {
    async function fetchData() {
      const resp = await APIRequest.V3.get(url(objectId, objectType));
      setModel(resp);
    }

    if (loadChart && !model) {
      fetchData();
    }
  }, [loadChart, model, objectId, objectType]);

  const hasMinimumSummaries = model?.summaries?.length >= MIN_SUMMARIES;

  if (!objectId || !hasMinimumSummaries) {
    return null;
  }

  const { chartData, chartOptions } = buildChartData(model);

  const classes = classNames(
    'price-history-chart',
    { 'price-history-chart--hidden': !hasMinimumSummaries },
  );

  return (
    <section
      className={classes}
    >
      <div className="price-history-chart__header">
        <div className="g-col-7">
          <h2 className="heading-3">{I18n.t('js.transactionHistory.chartHeader')}</h2>
        </div>
        <div className="g-col-5 align-right">
          <ul className="price-history-chart__legend">
            <li className="price-history-chart__label price-final">
              {I18n.t('js.transactionHistory.soldPrice')}
            </li>
          </ul>
        </div>
      </div>
      <div className="price-history-chart__line-chart">
        <LineGraph
          chartData={chartData}
          chartOptions={chartOptions}
          ariaLabel={I18n.t('js.transactionHistory.chartDescription')}
        />
      </div>
      <p className="fine-print muted mb-0">{I18n.t('js.transactionHistory.chartDescription')}</p>
    </section>
  );
}

export default PriceGuideChart;
